/// <reference path="../../setup/_references.ts" />
module onvio.clientDashboard {
    'use strict';

    /**
     * This is a collection of client information services to use when setting up the client dashboard
     */
    export class ClientDashboardClientInformationService {

        static $inject = ['$http'];
        constructor(private $http: ng.IHttpService) { }

        /**
         * Load the company mapping record if one exists
         * @param {*} companyId
         * @param {*} clientId
         */
        public loadCompanyMappings(companyId: string): ng.IPromise<CompanyMappings> {
            var api = '/api/smbcenter/v1/registration/parentCompany/{parentCompany}';
            api = api.replace('{parentCompany}', companyId);

            var opts = {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                };

            return this.$http({
                method: 'GET',
                url: api,
                headers: opts
            });
        }
    }

    // company mapping DTO
    export class CompanyMappingV1Dto {
        public id: string;
        public createdDate: string;
        public parentCompanyId: string;
        public parentOwningContactId: string;
        public clientId: string;
        public childCompanyId: string;
        public childOwningContactId: string;
        public acceptedDate: string;
    }

    export class CompanyMappings {
        data?: CompanyMappingV1Dto[];
    }

    angular.module('onvio.clientDashboard.ClientDashboardClientInformationService', [])
        .service('onvio.clientDashboard.ClientDashboardClientInformationService', ClientDashboardClientInformationService);
}
